import type { LinkField } from '@/types';

export const getLinkBindings = (link: LinkField | undefined) => {
  const bindings: Record<string, string | undefined> = {
    target: link?.value?.target ? link?.value?.target : '_self',
    alt: link?.value?.alt,
  };

  const href = link?.value?.href;
  if (link?.value?.linktype === 'internal' && href) bindings.to = href;
  else if (href) bindings.href = href;
  return bindings;
};

export const getLinkTag = (
  linktype: string | undefined,
  href: string | null | undefined
): string => {
  if (linktype === 'internal') return href ? 'router-link' : 'span';
  return 'a';
};
